import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import { User } from 'us-web-services';
import useAuthentication from '../../store/useAuthentication';

interface Props extends RouteComponentProps {
  user: User;
}

function LookupTabs(props: Props) {
  const authenticationState = useAuthentication()[0];
  const authenticatedUser = authenticationState.authentication.user;
  const { history, location, user } = props;
  const userId = user.id;
  const isPaymentAdmin = authenticatedUser.roles.filter(role => role.code === 'PAYMENT_ADMIN').length > 0;
  const isAgency = !user.parent && !user.sitter;

  const tabs = [
    { label: 'Details', path: '/users/lookup' },
    ...(!isAgency ? [{ label: 'Reviews', path: '/users/reviews' }] : []),
    { label: 'Transactions', path: '/users/transactions' },
    ...(!isAgency ? [{ label: 'Plans', path: '/users/plans' }] : []),
    ...(user.parent && isPaymentAdmin ? [{ label: 'Reimbursement', path: '/users/reimbursement' }] : []),
    ...((user.parent || user.sitter) ? [{ label: 'Bookings', path: '/users/bookings' }] : []),
  ];

  const currentTab = tabs.findIndex(tab => location.pathname === tab.path);
  const activeTab = currentTab >= 0 ? currentTab : 0;

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    const tab = tabs[newValue];

    if (tab) {
      history.push(`${tab.path}?id=${userId}`);
    }
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        textColor='primary'
        indicatorColor='primary'
        sx={{
          '& .MuiTab-root': {
            fontWeight: 400,
            opacity: 0.7,
          },
          '& .Mui-selected': {
            fontWeight: 600,
            opacity: 1,
            backgroundColor: 'rgba(0, 187, 205, 0.08)',
          },
          '& .MuiTabs-indicator': {
            height: 3,
          },
        }}
      >
        {tabs.map(tab => (
          <Tab key={tab.path} label={tab.label} />
        ))}
      </Tabs>
    </Box>
  );
}

export default withRouter(LookupTabs);
